import { UsPhoneLabel } from 'ui/components'
import { CheckMark } from 'ui/components/CheckMark'
import { DateTime } from 'ui/components/DateTime'
import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { TableActions, TableActionsItem, TableColumn } from 'ui/components/Table'
import { Tooltip } from 'ui/components/Tooltip'

import { UsersWebPageUser } from '../../../../types'
import { UsersTableProps } from './UsersTable.types'

import { s } from './styles'

export const columns = ({
  onEdit,
  onChangeStatus,
  onResetPassword,
  onResetMFA
}: UsersTableProps): TableColumn<UsersWebPageUser>[] => [
  {
    title: 'First Name',
    align: 'center',
    render: ({ active, firstName }) => <s.Text $inactive={!active}>{firstName}</s.Text>
  },
  {
    title: 'Last Name',
    align: 'center',
    render: ({ lastName, active }) => <s.Text $inactive={!active}>{lastName}</s.Text>
  },
  {
    title: 'Role',
    align: 'left',
    render: ({ role, active, id }) => (
      <s.TooltipContainer>
        <s.Text $inactive={!active}>{role.name}</s.Text>
        {role.description && (
          <s.TooltipWrapper>
            <Tooltip id={`role-${id}`} type="dark" content={<>{role?.description}</>}>
              <Icon name={IconName.INFO} size={IconSize.S} />
            </Tooltip>
          </s.TooltipWrapper>
        )}
      </s.TooltipContainer>
    )
  },
  {
    title: 'Email',
    align: 'center',
    render: ({ email, active }) => <s.Text $inactive={!active}>{email}</s.Text>
  },
  {
    title: 'Phone',
    align: 'center',
    render: ({ phone, active }) => (
      <s.Text $inactive={!active}>
        <UsPhoneLabel value={phone || ''} />
      </s.Text>
    )
  },
  {
    title: 'Active',
    align: 'center',
    render: ({ active }) => (active ? <CheckMark value={active} rounded label="" /> : null)
  },
  {
    title: 'Created',
    align: 'center',
    render: ({ createdAt, active }) => (
      <s.TextBlock $inactive={!active}>
        <DateTime date={createdAt} withTime />
      </s.TextBlock>
    )
  },
  {
    title: 'Last Login',
    align: 'center',
    render: ({ lastLogin, active }) => (
      <s.TextBlock $inactive={!active}>
        <DateTime date={lastLogin} withTime />
      </s.TextBlock>
    )
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) => {
      const result: TableActionsItem[] = [
        ...(item.enableDeactivate
          ? [
              {
                type: 'option' as const,
                title: item.active ? 'Deactivate User' : 'Activate User',
                onClick: () => onChangeStatus(item)
              }
            ]
          : []),
        ...(item.enableEdit
          ? [
              {
                type: 'edit' as const,
                onClick: () => onEdit(item)
              }
            ]
          : []),
        ...(item.enablePasswordResetOrInvite
          ? [
              {
                type: 'option' as const,
                title: item.lastLogin ? 'Reset Password' : 'Send Invite',
                onClick: () => onResetPassword(item)
              }
            ]
          : []),
        ...(item.enableDeleteAllMFA
          ? [
              {
                type: 'option' as const,
                title: 'Reset MFA',
                onClick: () => onResetMFA(item)
              }
            ]
          : [])
      ]

      return result.length > 0 && <TableActions items={result} />
    }
  }
]
